
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire77fb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire77fb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

parcelRegister("lQVoc", function(module, exports) {

$parcel$export(module.exports, "showSpinner", function () { return $fe8af8a42c4a74bc$export$2a7a135fa1ec651f; });
$parcel$export(module.exports, "hideSpinner", function () { return $fe8af8a42c4a74bc$export$95fec50f68454318; });
$parcel$export(module.exports, "showModal", function () { return $fe8af8a42c4a74bc$export$d7e8d4d4450c819c; });
$parcel$export(module.exports, "closeModal", function () { return $fe8af8a42c4a74bc$export$3f6fecd573f3fa48; });
$parcel$export(module.exports, "toggleMute", function () { return $fe8af8a42c4a74bc$export$8ed30069de84a7d6; });

var $5PzR5 = parcelRequire("5PzR5");

var $4wWXf = parcelRequire("4wWXf");

var $gRKH7 = parcelRequire("gRKH7");
const $fe8af8a42c4a74bc$export$ca6dda5263526f75 = "https://be-spin-mtn.ydafrica.com";
function $fe8af8a42c4a74bc$export$4670d0ed237a9270(num) {
    return "\u20A6" + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}
function $fe8af8a42c4a74bc$export$3ae94a2503e890a1(date, divider) {
    if (typeof date === "string" || typeof date === "number") date = new Date(date);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    day = day >= 10 ? day : "0" + day;
    month = month >= 10 ? month : "0" + month;
    return `${day}${divider}${month}${divider}${year}`;
}
function $fe8af8a42c4a74bc$export$2a7a135fa1ec651f(button) {
    const spinner = document.createElement("img");
    spinner.src = (0, (/*@__PURE__*/$parcel$interopDefault($gRKH7)));
    spinner.classList.add("spinner");
    button.appendChild(spinner);
    button.disabled = true;
}
function $fe8af8a42c4a74bc$export$95fec50f68454318(button) {
    const spinner = button.querySelector(".spinner");
    if (spinner) button.removeChild(spinner);
    button.disabled = false;
}
function $fe8af8a42c4a74bc$export$d7e8d4d4450c819c(modalId, message) {
    const modal = document.getElementById(modalId);
    document.getElementById("modal-body").textContent = message;
    modal.showModal();
}
function $fe8af8a42c4a74bc$export$3f6fecd573f3fa48(modalId) {
    const modal = document.getElementById(modalId);
    if (modal && typeof modal.close === "function") modal.close();
    else console.error("Modal not found or does not support close method");
}
function $fe8af8a42c4a74bc$export$80cb197f7ea4fe13(audio) {
    audio.loop = true;
    audio.play();
}
function $fe8af8a42c4a74bc$export$ae67b5b996057a24(audio) {
    audio.pause();
    audio.currentTime = 0;
}
function $fe8af8a42c4a74bc$export$8ed30069de84a7d6(audio, muteIcon) {
    audio.muted = !audio.muted;
    muteIcon.src = audio.muted ? (0, (/*@__PURE__*/$parcel$interopDefault($4wWXf))) : (0, (/*@__PURE__*/$parcel$interopDefault($5PzR5)));
}

});
parcelRegister("5PzR5", function(module, exports) {
module.exports = new URL("volume.69398795.svg", import.meta.url).toString();

});

parcelRegister("4wWXf", function(module, exports) {
module.exports = new URL("mute.bf4afe9f.svg", import.meta.url).toString();

});

parcelRegister("gRKH7", function(module, exports) {
module.exports = new URL("spinner-white.0e04d9db.svg", import.meta.url).toString();

});


parcelRegister("RE74v", function(module, exports) {

$parcel$export(module.exports, "getUserDetails", function () { return $0a1410f83330b0c5$export$714d3544202969b; });
$parcel$export(module.exports, "logoutUser", function () { return $0a1410f83330b0c5$export$e8df664d4863167e; });
$parcel$export(module.exports, "checkAuthToken", function () { return $0a1410f83330b0c5$export$60a2f6ea01f2d63c; });
const $0a1410f83330b0c5$var$baseUrl = "https://be-spin-mtn.ydafrica.com";
async function $0a1410f83330b0c5$export$714d3544202969b(token) {
    try {
        const response = await fetch(`${$0a1410f83330b0c5$var$baseUrl}/api/v1/auth-user`, {
            method: "GET",
            headers: {
                "x-auth-token": token,
                "Accept": "application/json",
                "Content-Type": "application/json"
            }
        });
        if (!response.ok) {
            console.error("Failed to fetch user details:", response.status, response.statusText);
            $0a1410f83330b0c5$export$e8df664d4863167e();
            return null;
        }
        const data = await response.json();
        if (!data.msisdn) {
            console.error("No MSISDN in response");
            $0a1410f83330b0c5$export$e8df664d4863167e();
            return null;
        }
        return data;
    } catch (error) {
        console.error("Error fetching user details:", error);
        $0a1410f83330b0c5$export$e8df664d4863167e();
        return null;
    }
}
async function $0a1410f83330b0c5$export$5c7af466649a12b3() {
    let token = localStorage.getItem("x-auth-token"); // Correctly retrieve token here
    if (!token || $0a1410f83330b0c5$var$isTokenExpired(token)) {
        console.error("No token found or token expired, please log in.");
        $0a1410f83330b0c5$export$e8df664d4863167e();
        return;
    }
    try {
        const response = await fetch(`${$0a1410f83330b0c5$var$baseUrl}/api/v1/auth-user`, {
            method: "GET",
            headers: {
                "x-auth-token": token,
                "Accept": "application/json",
                "Content-Type": "application/json"
            }
        });
        if (!response.ok) {
            console.error("Failed to fetch MSISDN:", response.status, response.statusText);
            $0a1410f83330b0c5$export$e8df664d4863167e();
            return null;
        }
        const userMsisdn = await response.json();
        if (!userMsisdn.msisdn) {
            console.error("No MSISDN in response");
            $0a1410f83330b0c5$export$e8df664d4863167e();
            return null;
        }
        let msisdn = userMsisdn.msisdn;
        let phone = document.querySelector("#phone");
        if (phone) phone.value = msisdn;
        return msisdn;
    } catch (error) {
        console.error("Error fetching MSISDN:", error);
        $0a1410f83330b0c5$export$e8df664d4863167e();
        return null;
    }
}
function $0a1410f83330b0c5$export$e8df664d4863167e() {
    localStorage.removeItem("x-auth-token");
    localStorage.removeItem("isLoggedIn");
    window.location.href = "/";
    console.log("User logged out");
}
function $0a1410f83330b0c5$var$isTokenExpired(token) {
    if (!token) return true;
    try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(atob(base64).split("").map((c)=>{
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
        const decodedToken = JSON.parse(jsonPayload);
        const currentTime = Date.now() / 1000;
        return decodedToken.exp < currentTime;
    } catch (error) {
        console.error("Error decoding token:", error);
        return true;
    }
}
function $0a1410f83330b0c5$export$60a2f6ea01f2d63c() {
    let token = localStorage.getItem("x-auth-token");
    if (!token || $0a1410f83330b0c5$var$isTokenExpired(token)) {
        console.error("Token missing or expired");
        $0a1410f83330b0c5$export$e8df664d4863167e();
    }
}

});

var $8c6e002541452f88$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["7bk21","index.0f790316.js","6xVCi","xmas.3a19442e.mp3","5cBGz","game-music.01b57f94.mp3","3hFvV","volume.69398795.svg","8hMWx","mute.bf4afe9f.svg","cbBha","spinner-white.0e04d9db.svg","fgVcx","starsbg.16ebe800.svg","1g4MR","starsmobile.b46b677e.svg"]'));

var $a5ed2432ddda5829$exports = {};
$a5ed2432ddda5829$exports = new URL("xmas.3a19442e.mp3", import.meta.url).toString();


var $4098787521211baa$exports = {};
$4098787521211baa$exports = new URL("game-music.01b57f94.mp3", import.meta.url).toString();



var $lQVoc = parcelRequire("lQVoc");
const $27435ee7e70aa165$var$baseUrl = "https://be-spin-mtn.ydafrica.com";
function $27435ee7e70aa165$export$3e7fdc7b0d1547e1() {
    const button = document.querySelector("#submit-btn");
    const telephone = document.querySelector("#telephone");
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (isLoggedIn) $27435ee7e70aa165$var$updateUIForLoggedInUser(localStorage.getItem("userPhone"));
    else {
        button.addEventListener("click", $27435ee7e70aa165$var$handleSubmit);
        telephone.addEventListener("input", $27435ee7e70aa165$var$handleInput);
    }
}
function $27435ee7e70aa165$var$handleInput() {
    const button = document.querySelector("#submit-btn");
    const telephone = document.querySelector("#telephone");
    if (telephone.value) {
        button.style.backgroundColor = "#7DA1D6";
        button.disabled = false;
    } else {
        button.style.backgroundColor = "#D9D9D9";
        button.disabled = true;
    }
}
async function $27435ee7e70aa165$var$handleSubmit(e) {
    e.preventDefault();
    const button = document.querySelector("#submit-btn");
    const telephone = document.querySelector("#telephone");
    if (!telephone.value) {
        $27435ee7e70aa165$var$showModal("myModal", "Enter phone number to proceed");
        return;
    }
    try {
        (0, $lQVoc.showSpinner)(button);
        const response = await fetch(`${$27435ee7e70aa165$var$baseUrl}/api/v1/auth-user`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                msisdn: $27435ee7e70aa165$var$formatPhoneNumber(telephone.value)
            })
        });
        const data = await response.json();
        if (data.status === 200) {
            $27435ee7e70aa165$var$closeModal("loginModal");
            $27435ee7e70aa165$var$showModal("myModal", "Login successful!");
            localStorage.setItem("x-auth-token", data.token);
            localStorage.setItem("isLoggedIn", "true");
            localStorage.setItem("userPhone", telephone.value);
            $27435ee7e70aa165$var$updateUIForLoggedInUser(telephone.value);
            setTimeout(()=>{
                window.location.href = "play.html";
            }, 1000);
        } else $27435ee7e70aa165$var$handleResponse(data, "myModal");
    } catch (error) {
        console.error("Error during fetch:", error);
        $27435ee7e70aa165$var$showModal("myModal", "Network error. Please try again.");
    } finally{
        (0, $lQVoc.hideSpinner)(button);
    }
}
function $27435ee7e70aa165$var$handleResponse(data, modalId) {
    let msg = document.getElementById("modal-body");
    let subMsg = document.getElementById("submodal-body");
    if (data.status === 500) {
        $27435ee7e70aa165$var$closeModal("loginModal");
        msg.innerHTML = data.msg;
        $27435ee7e70aa165$var$showModal("myModal");
        return;
    }
    if (data.status === 400) {
        $27435ee7e70aa165$var$closeModal("loginModal");
        subMsg.innerHTML = data.msg;
        // Set up the link in the subModal to open the subscription modal when clicked
        const subLink = document.getElementById("subLink");
        subLink.onclick = (e)=>{
            e.preventDefault();
            $27435ee7e70aa165$var$closeModal("subModal");
            $27435ee7e70aa165$var$showModal("subPackageModal");
        };
        $27435ee7e70aa165$var$showModal("subModal");
        return;
    }
}
function $27435ee7e70aa165$var$formatPhoneNumber(msisdn) {
    return msisdn.startsWith("+234") && msisdn.length === 14 ? msisdn.slice(4) : msisdn;
}
function $27435ee7e70aa165$var$showModal(modalId, message) {
    const modal = document.getElementById(modalId);
    document.getElementById("modal-body").textContent = message;
    modal.showModal();
}
function $27435ee7e70aa165$var$closeModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal && typeof modal.close === "function") modal.close();
    else console.error("Modal not found or does not support close method");
}
function $27435ee7e70aa165$var$updateUIForLoggedInUser(phoneNumber) {
    const navLink = document.getElementById("prize-nav");
    if (navLink) {
        navLink.textContent = "My Prizes";
        navLink.href = "/prizes-won.html";
    }
    const home = document.getElementById("home");
    if (home) home.href = "/play.html";
    const formattedNumber = phoneNumber.startsWith("+234") ? phoneNumber : `+234${phoneNumber.substring(1)}`;
    const phoneDisplay = document.getElementById("phone-no");
    if (phoneDisplay) phoneDisplay.textContent = `HELLO ${formattedNumber}, YOU ARE LOGGED IN`;
    const userInfo = document.getElementById("userNum");
    userInfo.textContent = formattedNumber;
    const profileIcon = document.querySelector(".profile-icon");
    if (profileIcon) profileIcon.classList.remove("hidden");
    const loginButton = document.getElementById("login");
    const homeButton = document.getElementById("home-btn");
    if (loginButton) loginButton.style.display = "none";
    if (homeButton) {
        homeButton.textContent = "Let\u2019s Spin";
        homeButton.onclick = ()=>{
            window.location.href = "play.html";
        };
    }
}


const $4b63714b946d0bfa$var$baseUrl = "https://be-spin-mtn.ydafrica.com";
function $4b63714b946d0bfa$export$b6e9637db1de32a9() {
    const urlHashProp = window.location.hash;
    const telephone = atob(urlHashProp.substring(1));
    const phoneDisplay = document.getElementById("phone-no");
    const formattedNumber = telephone.startsWith("234") ? telephone : `+234${telephone.substring(1)}`;
    async function handleRedirect() {
        await fetch(`${$4b63714b946d0bfa$var$baseUrl}/api/v1/auth-user`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                msisdn: checkNumber(telephone)
            })
        }).then((data)=>data.json()).then((data)=>{
            if (data.status === 400) {
                phoneDisplay.textContent = `Welcome! Login to Spin Now.`;
                setTimeout(function() {
                    // hideSpinner();
                    // document.getElementById("submodal-body").innerHTML = data.msg;
                    showModal("loginModal");
                // const subLink = document.getElementById("subLink");
                // subLink.onclick = (e) => {
                //   e.preventDefault();
                //   closeModal("subModal");
                //   showModal("loginModal");
                // };
                }, 6000);
                throw new Error(data.msg);
            }
            if (data.status === 500) {
                phoneDisplay.textContent = `Welcome! Login to Spin Now.`;
                setTimeout(function() {
                    // hideSpinner();
                    document.getElementById("modal-body").innerHTML = data.msg;
                    showModal("myModal");
                    return false;
                }, 6000);
                throw new Error(data.msg);
            }
            if (data.status === 200) {
                // hideSpinner();
                document.getElementById("modal-body").innerHTML = "Success";
                localStorage.setItem("x-auth-token", data.token);
                localStorage.setItem("isLoggedIn", "true");
                localStorage.setItem("userPhone", telephone);
                updateUIForLoggedInUser(telephone);
                console.log(telephone);
                setTimeout(function() {
                    // showModal("myModal");
                    window.location.href = "play.html";
                }, 6000);
            }
        });
    }
    function checkNumber(msisdn) {
        if (msisdn.length > 12 && msisdn.length === 13) {
            msisdn = msisdn.slice(3);
            msisdn = `0${msisdn}`;
            return msisdn;
        }
        return msisdn;
    }
    function showModal(modalId) {
        const modal = document.getElementById(modalId);
        modal.showModal();
    }
    function closeModal(modalId) {
        const modal = document.getElementById(modalId);
        modal.close();
    }
    function updateUIForLoggedInUser(phoneNumber) {
        const navLink = document.getElementById("prize-nav");
        if (navLink) {
            navLink.textContent = "My Prizes";
            navLink.href = "/prizes-won.html";
        }
        if (phoneDisplay) phoneDisplay.textContent = `HELLO ${formattedNumber}, YOU ARE LOGGED IN`;
        const userInfo = document.getElementById("userNum");
        userInfo.textContent = formattedNumber;
        const profileIcon = document.querySelector(".profile-icon");
        if (profileIcon) profileIcon.classList.remove("hidden");
        const profile = document.querySelector(".profile");
        if (profile) profile.classList.remove("hidden");
        const loginButton = document.getElementById("login");
        const homeButton = document.getElementById("home-btn");
        if (loginButton) loginButton.style.display = "none";
        if (homeButton) {
            homeButton.textContent = "Let\u2019s Spin";
            homeButton.onclick = ()=>{
                window.location.href = "play.html";
            };
        }
    }
    window.addEventListener("load", handleRedirect);
}


// src/js/prize.js
function $eb82c387de266cb9$export$9cbfea0a85506fa0() {
    const descriptionBox = document.querySelector(".description-box.desktop");
    if (!descriptionBox) return;
    const originalContainer = descriptionBox.parentElement;
    document.querySelectorAll(".prize-box").forEach((box)=>{
        box.addEventListener("click", function() {
            // Remove active class from all prize boxes
            document.querySelectorAll(".prize-box").forEach((box)=>{
                box.classList.remove("active");
            });
            // Add active class to the clicked prize box
            this.classList.add("active");
            // Update title and description
            const title = this.getAttribute("data-title");
            const description = this.getAttribute("data-description");
            document.getElementById("prize-title").innerText = title;
            document.getElementById("prize-description").innerText = description;
            descriptionBox.style.borderColor = "#FCEE21";
            if (window.innerWidth <= 767) {
                this.after(descriptionBox);
                descriptionBox.classList.add("mobile");
                descriptionBox.style.display = "block";
            } else {
                originalContainer.appendChild(descriptionBox);
                descriptionBox.classList.remove("mobile");
                descriptionBox.style.display = "block";
            }
        });
    });
    // Handle window resize event
    window.addEventListener("resize", function() {
        if (window.innerWidth > 767) {
            // Append back to original container on desktop
            originalContainer.appendChild(descriptionBox);
            descriptionBox.classList.remove("mobile");
            descriptionBox.style.display = "block";
        }
    });
}


var $fcb1554895f975d6$exports = {};
$fcb1554895f975d6$exports = new URL("starsbg.16ebe800.svg", import.meta.url).toString();


var $d56767240444ae8f$exports = {};
$d56767240444ae8f$exports = new URL("starsmobile.b46b677e.svg", import.meta.url).toString();


function $17bdc2b3e9898d53$export$13c605bcb29fe896() {
    const body = document.body;
    const wheelImg = document.querySelector(".wheel-img");
    const goToWheelButton = document.querySelector(".home-btn");
    const phoneNo = document.getElementById("phone-no");
    const headerText = document.querySelector(".header-text");
    const muteBtn = document.getElementById("mute");
    const logo = document.getElementById("logo");
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    // Check if the user is on mobile
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    if (!wheelImg) return;
    if (isLoggedIn) {
        // element should be in their final state if the user is logged in
        goToWheelButton.classList.remove("hidden");
        phoneNo.classList.remove("hidden");
        headerText.classList.remove("hidden");
        muteBtn.classList.remove("hidden");
        logo.classList.remove("hidden");
        headerText.style.color = "white";
        body.style.background = `url(${isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($d56767240444ae8f$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($fcb1554895f975d6$exports)))}) no-repeat center/contain, linear-gradient(180deg, #0D0D19 0%, #1E2046 31%, #3A3086 68.5%, #8E74E2 100%)`;
        return; // Skip animation if user is logged in
    }
    // Initial state setup for the animation
    goToWheelButton.classList.add("hidden");
    phoneNo.classList.add("hidden");
    // Animation sequence
    setTimeout(()=>{
        const newText = document.createElement("p");
        wheelImg.style.transition = "transform 1s ease, top 1s ease";
        wheelImg.style.transform = "translateY(400px)";
        body.style.backgroundColor = "white";
        newText.textContent = "All you have to do";
        newText.classList.add("header-subtext");
        headerText.insertAdjacentElement("afterend", newText);
        setTimeout(()=>{
            body.style.backgroundColor = "#332C77";
            newText.style.color = "white";
            newText.textContent = "is spin";
            setTimeout(()=>{
                body.style.backgroundColor = "#191A37";
                wheelImg.style.transform = "translateY(400px) rotate(60deg)";
                newText.style.display = "none";
                setTimeout(()=>{
                    wheelImg.style.transform = "rotate(60deg) translateY(0)";
                    body.style.background = `url(${isMobile ? (0, (/*@__PURE__*/$parcel$interopDefault($d56767240444ae8f$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($fcb1554895f975d6$exports)))}) no-repeat center/ contain, linear-gradient(180deg, #0D0D19 0%, #1E2046 31%, #3A3086 68.5%, #8E74E2 100%)`;
                    goToWheelButton.classList.remove("hidden");
                    muteBtn.classList.remove("hidden");
                    logo.classList.remove("hidden");
                    phoneNo.classList.remove("hidden");
                    headerText.classList.remove("hidden");
                    headerText.style.color = "white";
                }, 1000);
            }, 2000);
        }, 1000);
    }, 2000);
}


function $6e4c3af3038f735a$export$81e17204574dbb93() {
    const hamburger = document.querySelector(".hamburger");
    const navLinks = document.querySelector(".nav-list");
    const links = document.querySelectorAll(".nav__items");
    hamburger.addEventListener("click", ()=>{
        navLinks.classList.toggle("open");
        navLinks.style.display = navLinks.style.display === "flex" ? "none" : "flex";
        links.forEach((link)=>{
            link.classList.toggle("fade");
            link.addEventListener("click", ()=>{
                navLinks.style.display = "none";
            });
        });
        hamburger.classList.toggle("togle");
    });
}



var $lQVoc = parcelRequire("lQVoc");
async function $0e4e75f3848ab511$export$51eb06e199e419() {
    const radioChecked = document.querySelector('input[name="subsPlan"]:checked');
    if (!radioChecked) {
        (0, $lQVoc.showModal)("myModal", "Please select a subscription plan.");
        return;
    }
    const selectedValue = radioChecked.value;
    // Navigate to SMS app with the corresponding keyword
    switch(selectedValue){
        case "200":
            window.location.href = "sms:205?body=SV"; // For ₦200 plan
            break;
        case "100":
            window.location.href = "sms:205?body=SP"; // For ₦100 plan
            break;
        case "50":
            window.location.href = "sms:205?body=SM"; // For ₦50 plan
            break;
        case "30":
            window.location.href = "sms:205?body=SE"; // For ₦20 plan
            break;
        default:
            (0, $lQVoc.showModal)("myModal", "Invalid subscription plan selected.");
    }
    (0, $lQVoc.closeModal)("subPackageModal");
}


const $51771e948b2bc95d$var$baseUrl = "https://be-spin-mtn.ydafrica.com";
let $51771e948b2bc95d$var$text = "";
async function $51771e948b2bc95d$export$f1f0464b3ba71bf5(e) {
    e.preventDefault();
    var selectedValue = document.querySelector('input[name="radio"]:checked').value;
    const userDetails = await getUserDetails();
    let msisdn = userDetails.msisdn;
    msisdn = msisdn.slice(3);
    msisdn = `0` + msisdn;
    await fetch(`${$51771e948b2bc95d$var$baseUrl}/api/v1/users/${msisdn}/price-point`, {
        method: "POST",
        headers: {
            "x-auth-token": token,
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            priceValue: Number(selectedValue)
        })
    }).then((data)=>data.json()).then((data)=>{
        if (data.status === 400) {
            $51771e948b2bc95d$var$text = data.response.msg;
            showModal("myModal", $51771e948b2bc95d$var$text);
        }
        const priceValueToken = data.pricepoint.doc.priceValue;
        localStorage.setItem("price-value-token", priceValueToken);
        if (localStorage.getItem("price-value-token")) window.location.href = "play.html";
    });
}



var $RE74v = parcelRequire("RE74v");

var $lQVoc = parcelRequire("lQVoc");
const $85a5f86b715fe7db$var$isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
if (!$85a5f86b715fe7db$var$isLoggedIn) (0, $4b63714b946d0bfa$export$b6e9637db1de32a9)();
function $85a5f86b715fe7db$var$setFinalState() {
    const goToWheelButton = document.querySelector(".home-btn");
    const phoneNo = document.getElementById("phone-no");
    const headerText = document.querySelector(".header-text");
    const muteBtn = document.getElementById("mute");
    if (goToWheelButton && phoneNo && headerText && muteBtn) {
        if ($85a5f86b715fe7db$var$isLoggedIn) {
            goToWheelButton.classList.remove("hidden");
            phoneNo.classList.remove("hidden");
            headerText.classList.remove("hidden");
            muteBtn.classList.remove("hidden");
            headerText.style.color = "white";
        }
    }
}
function $85a5f86b715fe7db$var$shouldPlayXmasMusic() {
    const today = new Date();
    const month = today.getMonth();
    const day = today.getDate();
    // Xmas music should play from December 15th to January 5th
    const isDecember = month === 11 && day >= 15;
    const isJanuary = month === 0 && day <= 5;
    return isDecember || isJanuary;
}
window.addEventListener("DOMContentLoaded", async ()=>{
    if (!$85a5f86b715fe7db$var$isLoggedIn) document.getElementById("profile").style.display = "none";
    (0, $eb82c387de266cb9$export$9cbfea0a85506fa0)();
    (0, $27435ee7e70aa165$export$3e7fdc7b0d1547e1)();
    (0, $17bdc2b3e9898d53$export$13c605bcb29fe896)();
    (0, $6e4c3af3038f735a$export$81e17204574dbb93)();
    const backgroundMusic = document.getElementById("backgroundMusic");
    const muteBtn = document.getElementById("mute");
    if (backgroundMusic && muteBtn) {
        // Check if it's Christmas time and decide which music to play
        if ($85a5f86b715fe7db$var$shouldPlayXmasMusic()) backgroundMusic.src = (0, (/*@__PURE__*/$parcel$interopDefault($a5ed2432ddda5829$exports))); // Play Christmas music
        else backgroundMusic.src = (0, (/*@__PURE__*/$parcel$interopDefault($4098787521211baa$exports))); // Play default music
        backgroundMusic.play().catch((error)=>console.log("Error auto-playing music:", error));
        muteBtn.addEventListener("click", ()=>(0, $lQVoc.toggleMute)(backgroundMusic, muteBtn));
    }
    const subscriptionButton = document.getElementById("subsPlan");
    if (subscriptionButton) subscriptionButton.addEventListener("click", (0, $0e4e75f3848ab511$export$51eb06e199e419));
    const pricePointButton = document.getElementById("nx-btn");
    if (pricePointButton) pricePointButton.addEventListener("click", (0, $51771e948b2bc95d$export$f1f0464b3ba71bf5));
    const logoutButton = document.getElementById("logout-btn");
    if (logoutButton) logoutButton.addEventListener("click", (0, $RE74v.logoutUser));
    // Ensure the Go to Wheel button and other elements are shown when the user navigates to the home page
    $85a5f86b715fe7db$var$setFinalState();
    window.addEventListener("popstate", $85a5f86b715fe7db$var$setFinalState); // Handle browser back/forward buttons
});


//# sourceMappingURL=index.0f790316.js.map
